import { cartLineCardExpandedStyles as styles } from "@iewccouk/Overrides/Widgets/Cart/CartLineCardExpanded";
import { colorStrings, mediaQueriesBP } from "@iewccouk/Utilities/variables";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.quoteOnly = {
    ...styles.quoteOnly,
    size: 14,
    color: colorStrings.commonGlobalWhite,
    css: css`
        background-color: ${getColor(colorStrings.secondaryMain)};
        width: 100%;
        text-align: center;
        margin-block-end: 10px;
        line-height: 30px;
    `,
};

styles.moqContainer = {
    css: css`
        display: inline-flex;
        flex-direction: column;

        height: auto;
        border: 1px solid ${getColor(colorStrings.commonBorder)};
        background-color: ${getColor(colorStrings.commonGlobalGray04)};
        margin-block-end: 10px;
        width: 100%;

        padding: 10px;
    `,
};

styles.moqLabel = {
    css: css`
        font-size: 12px;
        font-weight: 400;
        color: ${getColor(colorStrings.textMain)};

        span {
            margin-inline-start: 5px;
        }
    `,
};

styles.cartLineNotes = {
    ...styles.cartLineNotes,
    label: {
        size: 14,
        color: colorStrings.primaryMain,
        css: css`
            button {
                font-size: 14px;
                color: ${getColor(colorStrings.primaryMain)};
            }
        `,
    },
};

styles.cartLineNotesGridItemServices = {
    css: css`
        display: flex;
        align-items: center;
        gap: 5px;
        flex-wrap: wrap;
    `,
};

styles.servicesLink = {
    typographyProps: {
        size: 14,
    },
    css: css`
        margin: 0;
    `,
};

styles.allowLooseEndsLabel = {
    size: 14,
};

styles.badgeAreaWrapper = {
    css: css`
        position: relative;
    `,
};

styles.badgeTextWrapper = {
    css: css`
        display: none;
        ${mediaQueriesBP.minMD} {
            position: absolute;
            width: auto;
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            height: max-content;
            & > div {
                height: 100%;
                line-height: normal;
                padding: 3px 10px;
                display: flex;
                align-items: center;
            }
        }
    `,
};

styles.badgeImageWrapper = {
    css: css`
        display: none;
        ${mediaQueriesBP.minMD} {
            position: absolute;
            width: 25%;
            height: 25%;
            left: 50%;
        }
    `,
};

styles.badgeText = {
    weight: "bold",
    size: 14,
    css: css`
        width: 100%;
        margin: auto;

        ${wrapInContainerStyles}
    `,
};

styles.imageBadgeGridItem = {
    width: 12,
    css: css`
        display: block;
        min-height: 30px;
        padding: 0 10px;
    `,
};

styles.textBadgeGridItem = {
    width: 12,
    css: css`
        &&& {
            display: block;
            min-height: 30px;
            padding: 0 6px;
            margin-top: 8px;
        }
    `,
};

styles.textBadgeStyles = {
    badge: {
        css: css`
            position: absolute;
            width: auto;
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            height: max-content;

            & > div {
                height: 100%;
                line-height: normal;
                padding: 3px 10px;
                display: flex;
                align-items: center;
            }
        `,
    },
    badgeText: {
        weight: "bold",
        size: 14,
        css: css`
            width: 100%;
            margin: auto;

            ${wrapInContainerStyles}
        `,
    },
};

styles.imageBadgeStyles = {
    container: {
        css: css`
            width: 60%;
            margin-bottom: 5px;
        `,
    },
    imageItem: {
        css: css`
            margin: 5px 0;
        `,
    },
};

styles.quoteOnlyBadge = {
    css: css`
        width: 100%;
        font-size: 14px;
        padding: 5px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${getColor(colorStrings.secondaryMain)};
        color: ${getColor(colorStrings.commonGlobalWhite)};
    `,
};

styles.quantityDiscounts = {
    viewLink: {
        typographyProps: {
            size: 12,
        },
    },
};

styles.addToListLink = {
    typographyProps: {
        size: 12,
    },
};

styles.productAvailability = {
    ...styles.productAvailability,
    container: {
        css: css`
            padding: 0 3px;
            margin: 10px 0 0;
        `,
    },
};

styles.extendedUnitNetPriceText = {
    ...styles.extendedUnitNetPriceText,
    size: 20,
};

styles.productPrice = {
    ...styles.productPrice,
    priceLabelText: {
        size: 14,
        css: css`
            margin-bottom: -5px;
        `,
    },
    price: {
        priceText: {
            size: 22,
        },
    },

    wrapper: {
        css: css`
            margin: 5px 0;
        `,
    },
};

styles.quantityGridItem = {
    ...styles.quantityGridItem,
    width: [12, 6, 6, 4, 4],
    css: css`
        div {
            width: 100%;
        }
        .customUOM {
            top: 58% !important;
        }
    `,
};
styles.extendedUnitNetPriceGridItem = {
    ...styles.extendedUnitNetPriceGridItem,
    width: [12, 6, 6, 8, 8],
};

styles.qtyLabel = {
    ...styles.qtyLabel,
    size: 12,
    css: css`
        margin-bottom: -5px;
    `,
};

styles.quantity = {
    ...styles.quantity,
    editableQuantityTextField: {
        labelProps: {
            css: css`
                margin-bottom: -10px;
                padding-top: 10px;
            `,
        },
    },
};

styles.cartLineServicesGridItem = {
    ...styles.cartLineServicesGridItem,
    width: 12,
    css: css`
        padding-top: 0;
    `,
};

styles.quantityDiscounts = {
    ...styles.quantityDiscounts,
    viewLink: {
        typographyProps: {
            size: 14,
        },
    },
};

styles.addToListLink = {
    ...styles.addToListLink,
    typographyProps: {
        size: 14,
    },
};

styles.minOrderAndMultiplesOf = {
    message: {
        color: colorStrings.textMain,
        forwardAs: "span",
        variant: "legend",
    },
};
